import { brazeAuth } from 'Services/api/braze';

export const startBrazeSession = async (userId: string): Promise<void> => {
	const { automaticallyShowInAppMessages, changeUser, openSession } = await import('Services/braze/brazeExports');
	const { signedBrazeSignature } = await brazeAuth();
	changeUser(userId, signedBrazeSignature);
	automaticallyShowInAppMessages();
	openSession();
};
